import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { ComponentRegistry } from 'core/registry';
import { ModalTitle } from 'legacyComponents/styled/lib';
import { ProTip } from 'apps/components/shared';
import { MenuOption } from 'legacyComponents/layout/menuOption';

import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { Modal } from 'apps/modals/views/modal';
import { FormDivider } from 'apps/signIn/styles';

import { CollectionConnManager } from 'apps/collection/main/connManager';
import { CollectionListItem } from 'apps/collection/views/collectionListItem';
import { CollectionForm } from 'apps/collection/collectionForm/index';
import { conf } from 'apps/collection/config.yaml';

import {
  Wrapper,
  ButtonStyled,
} from 'apps/collection/addToCollection/addToCollectionModal.styles';

@withNamespaces()
@observer
export class AddToCollectionModal extends Modal {
  UNSAFE_componentWillMount() {
    this.appManager = new CollectionConnManager(null, {
      profile: clientStore.signedInProfile,
      batchSize: 100,
      loadInstantly: true,
    });
  }

  newCollection = () => {
    modalStore.SetModalComponent(CollectionForm, modalStore.props);
  };

  render() {
    const collectionList = [];
    const collections = this.appManager.arrayApp;

    collections.forEach(collection => {
      collectionList.push(
        <CollectionListItem key={collection.id} collection={collection} />,
      );
    });
    const { projectName } = modalStore.props;

    return (
      <Wrapper>
        <ModalTitle>
          <Trans>
            Add {'"'}
            {{ projectName }}
            {'"'} to
          </Trans>
          :
        </ModalTitle>
        <FormDivider />
        <MenuOption
          onclick={this.newCollection}
          icon='add'
          title={conf.newCollection.title}
          description={conf.newCollection.description}
        />
        {collectionList}
        {collectionList.length === 0 ? '' : <FormDivider />}
        <ProTip size='small'>
          <strong>
            <Trans>Pro tip</Trans>:{' '}
          </strong>
          <Trans>
            starring a project also gives kudos to its creator(s) and
            collaborators
          </Trans>{' '}
          👌
        </ProTip>
        <ButtonStyled
          variant='secondary'
          onClick={this.props.clickCancel}
          text={<Trans>Cancel</Trans>}
          outline
        />
      </Wrapper>
    );
  }
}

ComponentRegistry.add('modals.AddToCollectionModal', AddToCollectionModal);
